import { Directive, OnDestroy } from '@angular/core';
import { Params, Router } from '@angular/router';

import { SessionStorageService } from 'ngx-webstorage';



@Directive()
export abstract class DetailWithQueryBase implements OnDestroy {
  parentQuery: Params;

  constructor(
    protected router: Router,
    protected sessionStorage: SessionStorageService
  ) {
    let locationState: Params = router.getCurrentNavigation()?.extras?.state;

    if (router.getCurrentNavigation()?.previousNavigation) {
      sessionStorage.store('locationState', locationState);
    } else {
      locationState = sessionStorage.retrieve('locationState');
    }
    this.parentQuery = locationState;
  }

  ngOnDestroy(): void {
    this.sessionStorage.clear('locationState');
  }
}
